import React from "react";

export default function Footer() {
  return (
    <footer>
      Developed by{" "}
      <a
        href="https://deevoid.netlify.app/"
        rel="noopener noreferrer"
        target="_blank"
      >
        Dev
      </a>
    </footer>
  );
}
